<template>
  <div class="Content">
    <div class="Panel">
      <div class="LeftBlock">
        <div class="BackPanel">
          <a href="./" class="BackLink">
            <div class="BlockShadow">
              <img src="./../../../assets/img/ReDesign/interface_icons/arrow_back.svg" alt=""/>
            </div>
          </a>
        </div>
      </div>
      <div class="RightBlock">
        <div class="TitlePanel">
          <h1>{{ companyName ? companyName : 'Компания не задана'}}</h1>
        </div>
      </div>
    </div>
    <div class="CatalogInfo">
      <div class="LeftBlock">
        <div class="FiltersBlock">
          <div class="SpaceBetween">
            <div class="Filters" ref="Filters">
              <CustomSelect
                v-model="filters.status"
                :options="statuses"
                placeholder="Статус модерации"
              />
            </div>
            <div class="FilterButtons">
              <button 
                style="height: 48px; font-size: 16px"
                class="btn-n-white" 
                @click="addedFilters()"
              >
                {{ applyFiltersText }}
              </button>
              <button 
                style="height: 48px; font-size: 16px"
                class="btn-n-white-no-border" 
                @click="resetFilters()"
              >
                {{ $t("pages.catalog.filters.buttons.reset") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="RightBlock">
        <div class="SearchBar" ref="SearchBar">
          <DefaultSearchInput
            style="width: 100%; height: 52px; max-width: 560px;"
            v-model="filters.searchFilter"
            :placeholder="$t('pages.catalog.inputs.search.placeholder')"
          />
        </div>
        <div
          v-if="isLoading"
          class="loader-container"
        >
          <div class="spinning-loader">
              <div class="spinner-ring ring-1"></div>
              <div class="spinner-ring ring-2"></div>
              <div class="spinner-ring ring-3"></div>
              <div class="center-dot"></div>
          </div>
          <div class="loading-text">{{ $t("pages.catalog.loader.title") }}</div>
        </div>
        <div v-else>
          <div
            v-if="filteredCourses.length > 0"
            class="PaginationContainer"
          >
            <div class="CoursesList">
              <div 
                v-for="course in filteredCourses" 
                :key="course.id"
                class="Questionnaires" 
              >
                <div class="Info">
                  <div class="TimePanel">
                    <div
                      v-if="course.status"
                      class="Status"
                      :class="{
                        Yellow: course.status?.status === 'Ожидает',
                        Green: course.status?.status === 'Одобрено',
                        Red: course.status?.status === 'Отклонено',
                      }"
                    >
                      <p>{{ course.status?.status }}</p>
                    </div>
                    <div>
                      <p>Создано {{ normalDate(course.createdAt) }}</p>
                    </div>
                    <div>
                      <p>Последнее обновление {{ normalDate(course.updatedAt) }}</p>
                    </div>
                  </div>
                  <div
                    v-if="course.status?.comment && 
                      course.status?.status === 'Отклонено'"
                    class="StatusComment Red"
                  >
                    <p>{{ course.status?.comment }}</p>
                  </div>
                  <div v-if="course.forWhom" class="LvlSkill">
                    <p>{{ course.forWhom }}</p>
                  </div>
                  <div class="NameCourse">
                    {{ course.name }}
                  </div>
                  <div v-if="course.description" class="DescCourse">
                    {{ course.description }}
                  </div>
                </div>
                <div class="Buttons">
                  <button
                    class="btn-n-white"
                    @click="() => {
                      deleteCourse(course.id)
                    }"
                  >
                    Удалить курс
                  </button>
                  <router-link
                    style="color: #1A1A1A"
                    class="btn-n-white btn-router-link"
                    :to="{
                      path: '/admin/org-statuses/catalog/update',
                      query: {
                        courseId: course.id
                      },
                    }"
                  >
                    Редактировать
                  </router-link>
                  <button
                    class="btn-n-white"
                    @click="() => {
                      requestModalShow = 1;
                      selectCourse = course;
                      dmCourseStatus = course.status?.status;
                      dmCourseStatusComment = course.status?.comment;
                      disableScroll();
                    }"
                  >
                    Изменить статус
                  </button>
                  <button
                    class="btn-n-white"
                    @click="() => {
                      requestModalShow = 2;
                      selectCourse = course;
                      disableScroll();
                    }"
                  >
                    История статусов
                  </button>
                </div>
              </div>
            </div>
            <Pagination
              class="LastElement"
              :key="`Pagination-${paginationKey}`"
              :dataCounter="filteredCoursesCount"
              :max_items="maxItems"
              :max_pages_indexes="5"
              :startPage="currentPage"
              @update:page="handlePageChange"
            />
          </div>
          <div
            v-else
            class="NoCourse" 
          >
            <div class="TitleQuest">
              <h2>{{ $t("pages.catalog.questionnaires.courses_not_found.title") }}</h2>
            </div>
            <p>{{ $t("pages.catalog.questionnaires.courses_not_found.comment_1") }}</p>
            <p>{{ $t("pages.catalog.questionnaires.courses_not_found.comment_2") }}</p>
            <p>Либо у данной УЦ нет курсов</p>
          </div>
        </div>
      </div>
    </div>
    <DefaultModal
      class="ModalEdit"
      v-if="requestModalShow === 1"
      rmtitle="Изменения статуса"
      rmdesc=""
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:FormBody>
        <CustomSelect
          v-model="dmCourseStatus"
          :options="statuses"
          placeholder="Выберите статус"
          label="Статус*"
        />
        <DefaultTextarea
          v-show="dmCourseStatus === 'Отклонено'"
          v-model="dmCourseStatusComment"
          @update:modelStatus="dmCourseStatusCommentValidate = $event"
          label="Причина отклонения"
        />
      </template>
      <template v-slot:ButtonsSection>
        <button
          style="font-size: 16px; height: 48px"
          :class="{
            'btn-n-yellow': dmCourseStatusCommentValidate,
            'btn-n-yellow-disabled': !dmCourseStatusCommentValidate
          }"
          @click.native="updateStatus"
        >
          Сохранить изменения
        </button>
        <button
          style="font-size: 16px; height: 48px"
          class="btn-n-white-no-border"
          @click.native="handleCloseModal"
        >
          Отменить изменения
        </button>
      </template>
    </DefaultModal>
    <DefaultModal
      class="ModalStatuses"
      v-if="requestModalShow === 2"
      rmtitle="История статусов"
      rmdesc=""
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:FormBody>
        <div v-if="selectCourse?.status" class="ModalBodyComponents">
          <div class="StatusInfo">
            <div
              class="Status"
              :class="{
                Yellow: selectCourse?.status?.status === 'Ожидает',
                Green: selectCourse?.status?.status === 'Одобрено',
                Red: selectCourse?.status?.status === 'Отклонено',
              }"
            >
              <p>{{ selectCourse?.status?.status }}</p>
            </div>
            <div class="FullDate">
              <p style="font-size: 16px">
                {{ normalDateTime(selectCourse?.status?.createdAt) }}
              </p>
            </div>
          </div>
          <div class="Vector"></div>
          <DefaultInput
            v-model="dateFilterStatus"
            placeholder="Дата статуса"
            type="date"
            :isValidate="false"
          />
          <div class="Statuses">
            <div v-for="status in filteredStatuses" :key="status.id">
              <div class="StatusInfo">
                <div
                  class="Status"
                  :class="{
                    Yellow: status.status === 'Ожидает',
                    Green: status.status === 'Одобрено',
                    Red: status.status === 'Отклонено',
                  }"
                >
                  <p>{{ status.status }}</p>
                </div>
                <div class="FullDate">
                  <p style="font-size: 16px">
                    {{ normalDateTime(status.createdAt) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="FontSize16px">В данный момент история статусов пустая</p>
        </div>
      </template>
      <template v-slot:ButtonsSection>
        <button
          style="font-size: 16px; height: 48px"
          class="btn-n-yellow"
          @click.native="handleCloseModal"
        >
          Принять
        </button>
      </template>
    </DefaultModal>
  </div>
</template>

<script>
import DefaultModal from "@/components/DefaultModal";
import Pagination from "@/components/OctaUI/Pagination.vue"; 
import DefaultInput from "@/components/OctaUI/Inputs/DefaultInput.vue";
import DefaultSearchInput from "@/components/OctaUI/Inputs/DefaultSearchInput.vue";
import CustomSelect from "@/components/OctaUI/Selects/CustomSelect.vue";
import DefaultTextarea from "@/components/OctaUI/Inputs/DefaultTextarea.vue";

import { getCoursesNProject } from "@/api/n_project.js";
import { createStatus } from "@/api/project_job_status.js";
import { ElNotification } from "element-plus";
import { removeJob } from "@/api/job.js";

import "@/assets/css/Repainting/Buttons.css";

export default {
  components: {
    DefaultModal,
    Pagination,
    DefaultInput,
    DefaultSearchInput,
    CustomSelect,
    DefaultTextarea
  },
  data() {
    return {
      // Курсы
      filteredCoursesCount: 0,
      courses: [],

      // Информация о компании
      companyName: null,
      nProjectId: null,

      // Данные для модалки
      scrollPosition: 0,
      requestModalShow: null,
      dateFilterStatus: null,
      selectCourse: null,
      dmCourseStatus: null,
      dmCourseStatusComment: null,
      dmCourseStatusCommentValidate: false,

      // Данные для пагинации
      paginationKey: Date.now(),
      maxItems: 8,
      currentPage: 1,

      // Данные для лоадера
      isLoading: true,

      // Данные для селектора статусов
      statuses: [
        { value: "Ожидает", name: "Ожидает" },
        { value: "Одобрено", name: "Одобрено" },
        { value: "Отклонено", name: "Отклонено" },
      ],

      // Данные для фильтров
      filters: {
        // Активный фильтры
        active: {},

        // Фильтр поиска
        searchFilter: '',

        // Фильтры левой панели
        status: null
      },

      // Сообщения
      msg: {
        title: {
          updateStatus: "Статус успешно обновлен",
          updateError: "Извините, произошла ошибка обновления",

          deleteCourse: "Курс успешно удален",
          deleteError: "Извините, произошла ошибка удаления",

          serverError: "Извините, произошла ошибка на сервере",
        },
        form: {
          success: {
            title: "Успех!",
            type: "success",
            position: "bottom-right",
            customClass: "ELDefaultNotification",
          },
          error: {
            title: "Упс!",
            type: "error",
            position: "bottom-right",
            customClass: "ELDefaultNotification"
          }
        }
      },
    };
  },
  mounted() {
    this.setCompanyInfo();
    this.getCourses();
  },
  watch: {
    "dmCourseStatus"() {
      if(this.dmCourseStatus !== "Отклонено")
        this.dmCourseStatusComment = null;
    }
  },
  computed: {
    filteredStatuses() {
      let statuses = [];

      if (this.selectCourse?.Project_Job_Statuses) {
        // Фильтрация
        statuses = this.selectCourse.Project_Job_Statuses.filter(
          (status) => {
            let dateStr = this.normalDate(status.createdAt);
            // По дате
            if (
              !this.dateFilterStatus ||
              dateStr.includes(this.dateFilterStatus)
            ) {
              return true;
            }

            return false;
          }
        );
      }

      return statuses;
    },
    filteredCourses() {
      let courses = [...this.courses];

      // Фильтрация
      courses = courses.filter(course => {
        // Поиск по названию
        if (!course.name.toLowerCase().includes(this.filters.searchFilter.toLowerCase())) {
          return false;
        }

        // Фильтр по статусам
        if (this.filters.active.status && 
          course.status?.status &&
          course.status.status !== this.filters.active.status) {
          return false;
        }
        
        return true;
      });

      // Перенаправление на 1 страницу, если количество курсов меньше текущей страницы
      if((this.currentPage - 1) * this.maxItems >= courses.length) {
        this.paginationKey++;
        this.handlePageChange(1);
      }

      // Записываем фактическое количество курсов после фильтрации до slice
      this.filteredCoursesCount = courses.length;

      // Возвращаем курсы для данной страницы(currentPage)
      return courses.slice(
        this.maxItems * (this.currentPage - 1), 
        this.maxItems * (this.currentPage - 1) + this.maxItems
      );
    },

    applyFiltersText() {
      let applyText = "Применить";
      let countFilters = 0;
      let filtersText = [
        "фильтр",
        "фильтра",
        "фильтров"
      ];

      // Считаем количество применнёных фильтров
      this.filters.status ? countFilters++ : '';

      /* На основе количества фильтров выбираем текст */
      // Если фильтров нет, возвращаем текст "Применить фильтры"
      if (countFilters === 0)
        return "Применить фильтры"
      // Если количество фильтров по модуль 10 равно 0 или (больше или равно 5), либо входит в 11-14
      // То возвращаем "Применить N фильтров"
      if (countFilters % 10 >= 5 || countFilters % 10 === 0 || [11, 12, 13, 14].find(item => item === countFilters))
        return applyText + " " + countFilters + " " + filtersText[2];
      // Иначе если количество фильтров по модуль 10 больше или равно 2
      // То возвращаем "Применить N фильтра"
      if (countFilters % 10 >= 2)
        return applyText + " " + countFilters + " " + filtersText[1];

      // Иначе возвращаем "Применить N фильтр"
      return applyText + " " + countFilters + " " + filtersText[0];
    }
  },
  methods: {
    setCompanyInfo() {
      this.nProjectId = this.$route.query?.nProjectId ? this.$route.query.nProjectId : null;
      this.companyName = this.$route.query?.companyName ? this.$route.query.companyName : null;

      // Если в ссылке задан стандартный статус, то он автоматически добавляется в фильтр
      if (this.$route.query?.statusDefault) {
        this.filters.status = this.$route.query.statusDefault;
        this.addedFilters();
      }
    },
    async updateStatus() {
      try {
        const result = await createStatus({
          status: this.dmCourseStatus, 
          comment: this.dmCourseStatusComment, 
          JobId: this.selectCourse.id, 
        });

        if (result.status === 200) {
          ElNotification({
            ...this.msg.form.success,
            message: this.msg.title.updateStatus,
          });
        } else {
          ElNotification({
            ...this.msg.form.error,
            message: this.msg.title.updateError,
          });
        }
      } catch(e) {
        ElNotification({
          ...this.msg.form.error,
          message: this.msg.title.serverError,
        });
      }

      // Обновляем данные компаний на странице до актуальных
      this.getCourses();

      this.handleCloseModal();
    },

    // Удаляем курс и обновляем данные на странице
    async deleteCourse(id) {
      try {
        const result = await removeJob([id]);

        if (result.status === 200) {
          ElNotification({
            ...this.msg.form.success,
            message: this.msg.title.deleteCourse,
          });
        } else {
          ElNotification({
            ...this.msg.form.error,
            message: this.msg.title.deleteError,
          });
        }
      } catch(e) {
        ElNotification({
          ...this.msg.form.error,
          message: this.msg.title.serverError,
        });
      }

      // Обновляем данные компаний на странице до актуальных
      this.getCourses();
    },

    async getCourses() {
      try {
        this.isLoading = true;
        this.courses = [];
        let countRequest = 0;
        let dataLastRequest = [];

        // Загружаем список курсов пакетами по maxItems
        while(countRequest === 0 || dataLastRequest.length > 0) {
          dataLastRequest = (await getCoursesNProject(
            this.maxItems, 
            countRequest * this.maxItems,
            this.nProjectId
          )).data;

          // Переводим некоторые данный в удобный вид
          for (const course of dataLastRequest) {
            // Сортируем статусы курса по возврастанию
            course.Project_Job_Statuses.sort((a, b) => a.id - b.id);

            course.status = this.getLastElement(
              course.Project_Job_Statuses
                ? course.Project_Job_Statuses
                : []
            );
          }

          this.courses.push(...dataLastRequest);

          // Если произошла загрузка первого пакета курсов - убираем лоадер
          if(countRequest === 0) {
            this.isLoading = false;
          }

          countRequest++;
        }
      } catch (e) {
        console.log(e);
      }
    },
    getLastElement(array) {
      if (array.length === 0) return null;

      return array[array.length - 1];
    },
    normalDate(date) {
      const newDate = new Date(date);
      const day = String(newDate.getDate()).padStart(2, "0");
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const year = newDate.getFullYear();

      return `${day}.${month}.${year}`;
    },
    normalDateTime(date) {
      const newDate = new Date(date);
      const day = String(newDate.getDate()).padStart(2, "0");
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const year = newDate.getFullYear();
      const hours = String(newDate.getHours()).padStart(2, "0");
      const minutes = String(newDate.getMinutes()).padStart(2, "0");
      const seconds = String(newDate.getSeconds()).padStart(2, "0");

      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    },
    handlePageChange(page) {
      this.currentPage = page; 
    },
    handleCloseModal() {
      this.requestModalShow = null;

      this.dateFilterStatus = null;

      this.enableScroll();
    },
    addedFilters() {
      this.filters.active = {};

      this.filters.status ? this.filters.active.status = this.filters.status : '';
    },
    resetFilters() {
      this.filters.active = {};

      this.filters.status = null;
    },
    disableScroll() {
        // Запоминаем позицию скролла
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        // Рассчитываем ширину скроллбара
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        
        // Блокируем скролл
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.width = '100%';
        document.body.style.height = '100%';

        // Компенсируем ширину скроллбара
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        
        // Для iOS Safari
        document.body.style.overscrollBehavior = 'none';
    },
    enableScroll() {
        // Восстанавливаем скролл
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.height = '';
        document.body.style.paddingRight = '';
        
        // Возвращаем позицию скролла
        window.scrollTo(0, this.scrollPosition);
        
        // Для iOS
        document.body.style.overscrollBehavior = '';
    },
  },
};
</script>

<style scoped>
p, h1, h2, h3, h4, h5, h6 {
  margin: 0;
  padding: 0;
}
.ModalEdit:deep(.RMView) {
  width: 352px;
}
.ModalStatuses:deep(.RMView) {
  width: 352px;
}
.LastElement {
  padding-top: 80px;
}
.SpaceBetween {
  position: relative;
  display: flex;

  flex-direction: column;
  justify-content: space-between;

  height: 100%;
}
.Content {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 40px;

  font-family: "Involve";
}
.Panel {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 24px;
}
.CatalogInfo {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 24px;
}
.Content p {
  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  color: #666666;
  position: relative;
  display: inline;
  width: fit-content;
  height: fit-content;
  max-width: 100%;
}
.LeftBlock {
  position: relative;
  display: flex;

  width: 264px;
  height: auto;

  flex-direction: column;
}
.FiltersBlock {
  position: sticky;

  width: 100%;
  height: fit-content;

  top: 20px;
}
.BackPanel {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: fit-content;
}
.BackLink {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  gap: 16px;
  text-decoration: none;
}
.BlockShadow {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 44px;
  height: 44px;
  background: #FFFFFF;
  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1), 0px 4px 4px -4px rgba(12, 12, 13, 0.05);
  border-radius: 8px;
  transition: 0.3s;
}
.BackLink:hover .BlockShadow {
  /* margin-right: 20px; */
  transition: 0.3s;
  background: #F8F8F8;
}
.Filters {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}
.FilterButtons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.RightBlock {
  display: flex;
  flex-direction: column;
  width: 840px;
}
.TitlePanel {
  position: relative;
  display: flex;
  
  width: 100%;
  height: fit-content;

  align-items: center;
}
.TitlePanel h1 {
  font-weight: 600;
  font-size: 32px;

  word-break: break-word;
}
.SearchBar {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.Questionnaires {
  display: flex;
  flex-direction: row;
  padding: 24px 24px 24px 24px;
  gap: 10px;
  margin-top: 24px;
  background: #FFFFFF;
  box-shadow: 0px 0px 16px 6px rgba(224, 224, 224, 0.2);
  border-radius: 16px;
}
.NoCourse {
  display: flex;
  flex-direction: column;
  padding: 24px 24px 24px 24px;
  gap: 4px;
  margin-top: 24px;
  background: #FFFFFF;
  box-shadow: 0px 0px 16px 6px rgba(224, 224, 224, 0.2);
  border-radius: 16px;
}
.LvlSkill {
  position: relative;
  display: flex;

  height: fit-content;
  width: fit-content;

  flex-direction: column;
  
  background: #F8F8F8;
  justify-content: center;
  align-items: center;
  padding: 5px 12px;
  border-radius: 4px;

  margin-top: 8px;
  word-break: break-word;
}
.NameCourse {
  position: relative;
  display: flex;

  height: fit-content;
  width: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 18px;
  line-height: 150%;

  color: #232323;
  
  margin-top: 8px;
  word-break: break-word;
}
.DescCourse {
  position: relative;
  display: flex;

  height: fit-content;
  width: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #666666;

  word-break: break-word;
}
.Info {
  position: relative;
  display: flex;

  width: 632px;
  height: fit-content;

  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.Status {
  position: relative;
  display: flex;

  width: fit-content;
  height: 29px;

  flex-direction: row;
  align-items: center;
  padding: 4px 12px;
  gap: 10px;

  border-radius: 4px;
}
.Statuses {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}
.StatusComment {
  position: relative;
  display: flex;

  width: fit-content;
  max-width: 548px;
  height: fit-content;

  flex-direction: column;
  align-items: center;
  padding: 4px 12px;
  gap: 10px;

  border-radius: 4px;
  word-break: break-word;
}
.TimePanel {
  position: relative;
  display: flex;

  width: 100%;
  height: 29px;

  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
  gap: 8px;
}
.Yellow {
  background: #fff0c3 !important;
}
.Yellow p {
  color: #876500 !important;
}
.Green {
  background: #e4ffea !important;
}
.Green p {
  color: #28a745 !important;
}
.Red {
  background: #ffe8e9 !important;
}
.Red p {
  color: #dc3545 !important;
}
.Buttons {
  position: relative;
  display: flex;

  width: 150px;
  height: fit-content;

  flex-direction: column;
  margin-top: auto;
  gap: 8px;
}
.CustomSelect {
  position: relative;
  display: flex;
  flex-direction: column;

  word-break: break-word;
}
.ModalBodyComponents {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  overflow-y: auto;
}
.ModalStatuses:deep(.RMBody) {
  overflow-y: auto;
}
.Vector {
  width: 100%;
  height: 0px;
  border: 1.5px solid #e0e0e0;
}
.FullDate {
  position: relative;
  display: flex;

  width: fit-content;
  height: 29px;

  align-items: center;
}
.StatusInfo {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  padding-right: 24px;
  flex-direction: row;
  justify-content: space-between;
}
.TitleQuest {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 70%;
}
.TitleQuest h2 {
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;
  color: #232323;
}
.TitleQuest a {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  margin-top: 8px;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #666666;
  transition: all 0.3s ease;
}
.TitleQuest a:hover {
  color: #F9D773;
}
.TitleQuest a:active {
  color: #1A1A1A;
;
}
.ShortInfo {
  display: flex;
  word-break: break-word;
  flex-direction: row;
  gap: 16px;
  margin-top: 8px;
}
.loader-container {
    text-align: center;
    margin-top: 80px;
}
.spinning-loader {
    position: relative;
    width: 80px;
    height: 80px;
    margin: 0 auto 20px;
}
.spinner-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    animation: spin 2s linear infinite;
}
.ring-1 {
    border: 3px solid transparent;
    border-top: 3px solid #F9D773E5;
    border-right: 3px solid #F9D773E5;
}
.ring-2 {
    border: 3px solid transparent;
    border-top: 3px solid #F9D77333;
    border-right: 3px solid #F9D77333;
    width: 70%;
    height: 70%;
    top: 15%;
    left: 15%;
    animation-duration: 1.5s;
    animation-direction: reverse;
}
.ring-3 {
    border: 3px solid transparent;
    border-top: 3px solid #F9D7731A;
    border-right: 3px solid #F9D7731A;
    width: 50%;
    height: 50%;
    top: 25%;
    left: 25%;
    animation-duration: 1s;
}
.center-dot {
    position: absolute;
    width: 12px;
    height: 12px;
    background: #F9D773E5;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: pulse-center 2s infinite ease-in-out;
}
.loading-text {
    color: #000000;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 2px;
    animation: pulse 2s infinite;
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@keyframes pulse {
    0%, 100% {
        opacity: 0.7;
        transform: scale(1);
    }
    50% {
        opacity: 1;
        transform: scale(1.05);
    }
}
@keyframes pulse-center {
    0%, 100% {
        transform: translate(-50%, -50%) scale(1);
        box-shadow: 0 0 10px #F9D773E5;
    }
    50% {
        transform: translate(-50%, -50%) scale(1.2);
        box-shadow: 0 0 20px #F9D773E5, 0 0 30px #F9D77333;
    }
}
</style>
